import AddChildAccount from '../../../components/Multi/ChildAccount/AddChildAccount';

const AddAccountPage = ({ isHolding = false }) => {
  return (
    <div>
      <AddChildAccount isHolding={isHolding} />
    </div>
  )
}
export default AddAccountPage
